module.exports = "/static/assets/5b39a8dcd1214babeefc01549921e89c.png";